import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import { setBaseUrl } from '@sara/api-client';
import { ThemeProvider } from '@sara/ui/hooks/use-theme';
import { captureReactError } from '@sara/ui/lib/sentry-error-boundary';
import { initSuperTokens } from './config/supertokens';
import { initSentry } from './config/sentry';
import { env } from './config/env';
import { queryClient, router } from './router';
import './index.css';

initSentry(env);
initSuperTokens();
setBaseUrl(env.VITE_API_DOMAIN);

createRoot(document.getElementById('root') as HTMLElement, {
  onCaughtError: captureReactError,
  onUncaughtError: captureReactError,
}).render(
  <StrictMode>
    <ThemeProvider defaultTheme="system">
      <SuperTokensWrapper>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </SuperTokensWrapper>
    </ThemeProvider>
  </StrictMode>
);
